import { useEffect, useState } from 'react';
import {
  CourierAreaFormatted,
  fetchCourierArea,
  fetchInbound,
  InboundInfoFormatted,
} from '../fetch/fetchInbound';

export function useGetInboundInfo(): {
  inboundInfoList: InboundInfoFormatted[];
  isLoading: boolean;
} {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [inboundInfoList, setInboundInfoList] =
    useState<InboundInfoFormatted[]>(null);

  useEffect(() => {
    const fetchInboundInfoListMethod = async () => {
      const InboundInfoListResult = await fetchInbound();

      setInboundInfoList(InboundInfoListResult);
      setIsLoading(false);
    };

    fetchInboundInfoListMethod();
  }, [setIsLoading]);

  return { inboundInfoList, isLoading };
}

export function useGetCourierAreaInfo(): {
  inboundInfoList: CourierAreaFormatted[];
  isLoading: boolean;
} {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [inboundInfoList, setInboundInfoList] =
    useState<CourierAreaFormatted[]>(null);

  useEffect(() => {
    const fetchInboundInfoListMethod = async () => {
      const InboundInfoListResult = await fetchCourierArea();

      setInboundInfoList(InboundInfoListResult);
      setIsLoading(false);
    };

    fetchInboundInfoListMethod();
  }, [setIsLoading]);

  return { inboundInfoList, isLoading };
}
